import React, { useRef, lazy, Component, Suspense, useState } from 'react';
import Header from '../../../layouts/Header';
import HeaderV1 from '../../../layouts/HeaderV1';
import Footer from '../../../layouts/Footer';
import { getSchoolDetails, storeUserAgent, commonAPI, getSchoolDetailsByTerm, getinsightcontent, saveEnqLead } from '../../../API/FetchCall';
import SocialMediaButtons from './../../SocialShare/socialShareV1';
//import { ReviewSchools } from './../Banner/ReviewComponent';
import { ReviewSchools } from './../../Banner/ReviewComponentV1';
import { SimilarNew } from './../../Banner/similarnew';
import { Invite } from './../../Banner/invite_people';
import { UncontrolledPopover, PopoverBody, Modal, ModalBody, Button } from 'reactstrap';
import { compose, withProps } from "recompose";

import { CommentsNew } from './../../Banner/commentsnew';
//import { LikeFollow } from './../Banner/like_follownew'; old

import { RetailList } from '../../retailer/retailer_list';
import { LikeOnly } from './../../Banner/likeV1';
import { FollowOnly } from './../../Banner/followV1';

import { LikeOnlyV2 } from './../../Banner/likeV2';
import { FollowOnlyV2 } from './../../Banner/FollowOnlyV2';

import { LikeVideo } from './../../Banner/like_video';
import { BASE_URL, REVIEWDAYS, REVIEWMSG, RATING_GOOGLE, SCREEN_SIZE, IMG_URL, AZ_ASSET_PATH } from '../../../constant';
import Rating from 'react-star-rating-component';
import { AdsOne, AdsTwo, ViewTop } from '../../../components/others/ads';
import { ContactInfo } from './../../Banner/contact_information';
import { AddWishlistNewV1 } from '../../Banner/addWishlistNewV1';
import { AddWishlistNewV1inBar } from '../../Banner/addWishlistNewV1inBar';
import Gallery from 'react-grid-gallery';
import { Player } from 'video-react';
import ReactTooltip from "react-tooltip";
import { iplocation, partnerSocialLinks } from '../../../common';
import Loading from './Loading.js';
import { SimilarResults, getSchoolCategoryIdBySlug, getNameBySlug, getLike, saveOnclicks } from '../../../API/FetchCall';

import { Helmet } from 'react-helmet';

import Comp1 from "./../../PageND/Comp1";
import Comp2 from "./../../PageND/Comp2";
import Comp3 from "./../../PageND/Comp3";
//import Comp4 from "./../PageND/Comp4";
import Comp5 from "./../../PageND/Comp5";
import Comp6 from "./../../PageND/Comp6";
import Comp7 from "./../../PageND/Comp7";
import Comp8 from "./../../PageND/Comp8";
import CompContact from "./../../PageND/CompContact";
import CompAdmissionProcess from "./../../PageND/CompAdmissionProcess";
import CompVideos from "./../../PageND/CompVideos";

import testorgphoto from "../../../../src/assets/images/schoolimage.png";
import actionicon from "./../../../assets/icons/schools.png";

import placeholderimage from "../../../../src/assets/images/schoolimage.png";
import  placeholderbgimage from "../../../../src/assets/images/bg/banner-image-faded.jpg";

import actionicon1 from "./../../../assets/icons/v2/compare.png";
import actionicon2 from "./../../../assets/icons/v2/review.png";
import actionicon3 from "./../../../assets/icons/v2/wishlist.png";
import actionicon4 from "./../../../assets/icons/v2/network.png";
import actionicon5 from "./../../../assets/icons/v2/phone-call.png";
import actionicon6 from "./../../../assets/icons/v2/customer-service.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';

import '../../../../src/assets/css/ionicons.min.css';

import '../../../../src/assets/css/custom.css';
import '../../../../src/assets/css/customV1.css';
import '../../../../src/assets/css/mobile.css';

import { AdHorizontal } from './../../Banner/AdHorizontal';
import { AdVertical,AdVerticalLeft } from './../../Banner/AdVertical';

import closebtn from '../../../../src/assets/icons/close.svg';

import InnerArticles from './../inner_articles';

import axios from 'axios'

 

const amenImageGrabber = (type) => {
  type = type.toLowerCase().trim();

  if (type === 'cctv') {
    return '../../../../assets/icons/indoor-sports.png';
  }
  if (type === 'ac_classrooms') {
    return '../../../../assets/icons/AC-classes.png';
  }
  if (type === 'outdoor_playarea') {
    return '../../../../assets/icons/swimming-icon.png';
  }
  if (type === 'tranportation') {
    return '../../../../assets/icons/transportation.png';
  }
  if (type === 'food_and_snacks') {
    return '../../../../assets/icons/outdoor-sports.png';
  }
  return '../../../../assets/icons/swimming-icon.png';
};

        var leadad = '';
        var leadlink = '';

        if(window.location.pathname.indexOf("/schools/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/School.png';
               leadlink = '/best-schools-near-me';
        }

        if(window.location.pathname.indexOf("/pre-schools/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Pre School.png';
               leadlink = '/best-preschools-near-me';
        }

        if(window.location.pathname.indexOf("/tuitions/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Tuitions.png';
               leadlink = '/best-tuitions-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/sports/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Sports.png';
               leadlink = '/best-sports-classes-near-me';
        }


        if(window.location.pathname.indexOf("after-school-activity/music") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Music Classes.png';
               leadlink = '/best-music-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/dance-and-theatre") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Dance.png';
               leadlink = '/best-dance-classes-near-me';
        }


        if(window.location.pathname.indexOf("after-school-activity/creative-arts") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Art.png';
               leadlink = '/best-arts-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/mind-and-skill-enrichment") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Enrichment.png';
               leadlink = '/best-skill-enrichment-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/hobbies-and-passion") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Hobby classes.png';
               leadlink = '/best-hobby-passion-enriching-classes-near-me';
        }


class SingleSchoolPageV3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      firstbrdcrm: '',
      secondbrdcrm: '',
      showcp: false,
      shownotecp:false,
      category_name: '',
      showHideComp1: false,
      showHideComp2: false,
      showHideComp3: false,
      showHideComp4: false,
      showHideComp5: false,
      showHideComp6: false,
      showHideComp7: false,
      showHideComp8: false,
      showHideCompContact: false,
      showHideAdmissionProcess: false,
      showVideos: false,
      isPartner: false,
      breadcrum: '',
      breadcrums: '',
      rating: [],
      review_social: 3,
      similarList: [],
      contentList: [],
      contact_info: false,
      authe: false,
      review_option: false,
      shareurl: window.location.href,
      average_fees: true,
      contact_info: false,
      error: false,
      school: null,
      socialShare: false,
      showing: false,
      noofreview: 0,

      user_city:'',
      user_state:'',
      country_name:'',
      ip:'',

      phone_number: "Click to View/Call",
      landline_number: "Click to View/Call",
      logged_auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
      readmore: true,
      schoolType: localStorage.getItem('sub_type'),
      search_link: localStorage.getItem('search_link') ? localStorage.getItem('search_link') : '',
      photo_path: [],
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'Bengaluru',
      comparedataoption1: localStorage.getItem("comparedataoption1") ? localStorage.getItem("comparedataoption1") : 0,
      comparedataoption2: localStorage.getItem("comparedataoption2") ? localStorage.getItem("comparedataoption2") : 0,
      comparedataoption3: localStorage.getItem("comparedataoption3") ? localStorage.getItem("comparedataoption3") : 0,
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCloseCp = this.handleCloseCp.bind(this);
    this.hideComponent = this.hideComponent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleCloseNoteCp = this.handleCloseNoteCp.bind(this);
    
  }

  handleCloseNoteCp = (e) => {
    this.setState({ shownotecp: false });
  }

  
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  changephonenumberState(phone_number) {
    this.setState({ phone_number: phone_number });
  }
  changelandline_noState(landline_number) {
    this.setState({ landline_number: landline_number });
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

  };  

  topics = async () => {
    try {
      let req = JSON.stringify({
        role: 4,
        category: 1
      })
      const response = await getinsightcontent(req);
      if (response.status === 1) {
        console.log("Dfgdgfd", response);
        this.setState({ contentList: response.list.slice(0, 5) });
      } else {
        this.setState({ contentList: [] });
      }

    } catch (error) {
      console.log(error);
      this.setState({ error: true });
    }
  };

  getIp = async () => {

    const res = axios.get('https://geolocation-db.com/json/');

    if(res.data){
       this.setState({ 
          ip: res.data.IPv4,
          user_city:res.data.city,
          user_state :res.data.state,
          country_name:res.data.country
       });
    }

  }

  getSubCategory(subcategory_name) {
    let name = subcategory_name;
    var paths = window.location.pathname.split("/");

    let breadcrums = '';
    this.setState({
      breadcrums: paths[3]
    })
    return breadcrums;
  }


  getCategory() {
    let id = this.props.match.params.category_id;
    let breadcrum = '';
    switch (id) {
      case '12':
        breadcrum = 'Open School';
        break;
      case '133':
        breadcrum = 'Special Needs';
        break;
      case '142':
        breadcrum = 'Public School';
        break;
      case '143':
        breadcrum = 'Private School';
        break;
      case '144':
        breadcrum = 'Boarding School';
        break;
      case '145':
        breadcrum = 'International School';
        break;
      case '147':
        breadcrum = 'Home School';
        break;
      default:
        breadcrum = 'Open School';
        break;
    }
    this.setState({
      breadcrum: breadcrum
    })
    return breadcrum;
  }
  componentDidMount() {

 

    //document.addEventListener("click", this.handleClickOutside);
    this.setState({
      city: this.props.match.params.city,
      subcategory: this.props.match.params.subcategory
    });

    this.setState({ showHideComp1: true });

    this.topics();
    this.getIp();


    localStorage.setItem('currentpath', window.location.pathname);

    var paths = window.location.pathname.split("/");

    var firstbrdcrm = "/" + paths[1] + "/" + paths[2];
    var secondbrdcrm = "/" + paths[1] + "/" + paths[2] + "/" + paths[3];
    this.setState({
      firstbrdcrm: firstbrdcrm,
      secondbrdcrm: secondbrdcrm
    });

    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    let userid, pid = '';
    if (data_auth) {
      let auth_data = JSON.parse(data_auth)
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
      });
      userid = auth_data.user_id;
      pid = auth_data.isPartner;
    } else {
      userid = '';
    }


    let data_auth_feedback = (localStorage.getItem("myData"));
    if (data_auth_feedback) {
      let auth_data = JSON.parse(data_auth_feedback);
      this.setState({
        first_name: auth_data.first_name,
        last_name: auth_data.last_name,
        email_id:auth_data.email_id
      });
    }
    

    let DetailData = JSON.stringify({
      school_term: this.props.match.params.schooname,
      user_id: userid,
    });

    getSchoolDetailsByTerm(DetailData).then((response) => {
      if (response.status == 1) {
        this.getSubCategory(response.data.category_name);
        this.setState({
          school: response.data, rating: response.rating,
          noofreview: response.rating.totalReviewers,
          phone_number_info: response.data.phone_number,
          error: false,
          last_review_date: response.rating.created_date ? response.rating.created_date : '',
        });
        if (response.data.vendor_id == pid) {
          this.setState({
            isPartner: true
          })
        }
        this.image_gallery(response.data.photos, 'https://bewiseblobprod.blob.core.windows.net/assets/bewise/');


        //common_fucntion.iplocation(response.data.vendor_id, 1, this.state.user_id, response.data.page_id);

        var created_date = response.rating.created_date;
        var date1 = new Date();
        var date2 = new Date(created_date);
        var diffDays = date1.getDate() - date2.getDate();
        if (created_date != '') {
          if (diffDays > REVIEWDAYS) {
            this.setState({
              review_option: true,
            });
          } else {
            this.setState({
              review_option: false,
            });
          }
        } else {
          this.setState({
            review_option: true,
          });
        }
      }
    });

    this.SResult();

    window.addEventListener('scroll', this.listenToScroll);


          let mainNavLinks = document.querySelectorAll(".btnblock a");
          let mainSections = document.querySelectorAll(".section_to_scroll");

          let lastId;
          let cur = [];

          // This should probably be throttled.
          // Especially because it triggers during smooth scrolling.
          // https://lodash.com/docs/4.17.10#throttle
          // You could do like...
          // window.addEventListener("scroll", () => {
          //    _.throttle(doThatStuff, 100);
          // });
          // Only not doing it here to keep this Pen dependency-free.

          window.addEventListener("scroll", event => {
            let fromTop = 400;
            console.log(fromTop);
            mainNavLinks.forEach(link => {
              let section = document.querySelector(link.hash);

              if (
                section.offsetTop <= fromTop &&
                section.offsetTop + section.offsetHeight > fromTop
              ) {
                link.classList.add("active");
              } else {
                link.classList.remove("active");
              }
            });
          });


  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      $(".floating-menu").addClass('hidden');
      $(".floating-menu-close-btn").addClass("hidden");
    }
  }




  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight

    const scrolled = winScroll / height
    //console.log(scrolled);
    if (scrolled > 0.108) {
      //document.getElementById("floatinmid").style.display = "flex";
    } else {
      //document.getElementById("floatinmid").style.display = "none";
    }
  }

  SResult() {

    let SlugName = JSON.stringify({
      category_slug: this.props.match.params.subcategory
    });

    getSchoolCategoryIdBySlug(SlugName).then((response) => {
      if (response.status == 1) {

        let slugData = JSON.stringify({
          slug: this.props.match.params.schooname,
          categoryname: 'schools'
        });

        getNameBySlug(slugData, 'schools').then((response2) => {
          if (response2.status == 1) {

            let reviewData = JSON.stringify({
              module: 1,
              ref_id: response2.id,
              category: response.subcategory_id,
              route: this.props.match.params.city + "/schools/" + this.props.match.params.subcategory
            });
            this.setState({ id: response2.id });

            SimilarResults(reviewData).then((response) => {
              if (response.status == 1) {
                this.setState({
                  similarList: response.results,
                  category_name: response.category_name,
                })
              }
            });
          }
        });

      }
    });
  }

  myFunction(x) {
    // x.classList.toggle("fa-thumbs-down");
    if (document.getElementById("ff").style.color == '#007bff')
      document.getElementById("ff").style.color = '#000000';
    else {
      document.getElementById("ff").style.color = '#007bff';
    }
    //document.getElementById("ff").style.color='#007bff';
  }
  socialShare() {
    this.setState(prevState => ({
      socialShare: !prevState.socialShare,
    }));
  }

  handle_AverageFees = (e) => {
    this.setState((prevState) => ({
      average_fees: !prevState.average_fees,
    }));
  };

  handleSubmit = (e) => {

    e.preventDefault();

    let reviewData = JSON.stringify({
      to_email: this.state.email_id,
      user_name: this.state.first_name+" "+this.state.last_name,
      vendor_id : this.state.school.vendor_id,
      vendor_name: this.state.school.schoolName,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      vertical: "schools",
      location:this.state.current_location,
      any_message: this.state.any_message,
      reg_email:this.state.reg_email,
      reg_mobile:this.state.reg_mobile,
      lead:"enquiry"
    });
    

    saveEnqLead(reviewData).then((response) => {
      if (response.status == 1) {
        
        this.setState({ showcp: false });

        let toastr = '';
        toastr = window.toastr.success; //warning
        toastr('Message sent to the Provider', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
        });


      }
    });


    

  };
  handle_Contact = (e) => {

    if (this.state.logged_auth) {
      this.setState({ contact_info: true });
    } else {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('Please Login your account', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    }
  };


  handleclick = (e) => {

    $(".floating-menu").toggleClass("hidden");
    $(".floating-menu-close-btn").toggleClass("hidden");

  }
  handleclickhide = (id, e) => {

    $('.menuitem').removeClass("highlighted");
    $('#' + id + '').toggleClass("highlighted");
    $(".floating-menu").addClass('hidden');
    $(".floating-menu-close-btn").addClass("hidden");
  }

  handleclose = (e) => {
    $(".floating-menu").addClass('hidden');
    $(".floating-menu-close-btn").addClass("hidden");
  }

  handleCloseCp = (e) => {
    this.setState({ showcp: false });
  }

  readmore = (e) => {
    $(".b5caz").removeClass("less");
    $(".b5caz").addClass("more");
    this.setState({
      readmore: false
    })
  }
  readless = (e) => {
    $(".b5caz").removeClass("more");
    $(".b5caz").addClass("less");
    this.setState({
      readmore: true
    })
  }

  // getSchoolDetails = async (id) => {
  //   try {
  //     const res = await getSchoolDetails(id);
  //     this.setState({
  //       school: res.data, rating: res.rating,
  //       phone_number_info: res.data.phone_number,
  //       error: false,
  //       last_review_date :res.rating.created_date ? res.rating.created_date : '',
  //     });
  //     // console.log(this.state.school);
  //     this.SResult(this.props.match.params.category_id);
  //     this.image_gallery(res.data.photos,res.data.url)
  //   } catch (error) {
  //     this.setState({ error: true });
  //   }
  // };






  scrollLocation() {
    var hash = "#location";
    $('html, body').animate({
      scrollTop: $(hash).offset().top - 200
    }, 800, function () {

    });
  }
  toggleModalopen = (e) => {
    this.setState({
      openModalLogin: true
    })
  }
  showContact = (e) => {
    this.setState({
      contact_info: true
    })
  }

  writereview = (e) => {

    if (!this.state.logged_auth) {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('Please Login your account to write a review', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    }

  }

  image_gallery(photos, url) {

    var photo_string = photos;
    var photo_arr = photo_string.split(",");
    photo_arr = photo_arr.filter(function (el) {
      return el != null && el != '';
    });
    var photo_path = [];
    // console.log('******', photo_arr);
    for (let p = 0; p < photo_arr.length; p++) {
      photo_path.push({
        src: url + photo_arr[p],
        thumbnail: url + photo_arr[p],
        thumbnailWidth: 320,
        thumbnailHeight: 174,
        caption: ""
      })
    }

    this.setState({
      photo_path: photo_path
    })
  }

  homeLink = () => {
    window.location.replace('/');
  }

  subLink = () => {
    window.location.replace('/schoollinks');
  }

  subCategoryLink = () => {
    window.location.replace('/' + this.state.city + '/' + 'school/' + this.state.subcategory);

  }

  searchLink = () => {
    window.location.replace(this.state.search_link);
    localStorage.setItem('search_link', "");
  }

  addtocompare = () => {

    if (this.state.logged_auth) {

      let id = this.state.id;
      let type = 'school';
      let toastr = '';
      var preschool = localStorage.getItem("school_compare") ? localStorage.getItem("school_compare") : '';
      if (preschool != 0) {
        var preschool_compare = JSON.parse(preschool);
      }

      if (preschool != 0) {

        let preschool_com_len = preschool_compare.length

        console.log(preschool_com_len);

        var myDomEl = $('#comparecounted');
        myDomEl.show();

        if (preschool_com_len < 3) {
          let preschool_check = preschool_compare.filter(o => o.id == id);
          console.log(preschool_compare);
          if (preschool_check != '') {
            console.log('if if')

            myDomEl.html(preschool_com_len);

            toastr = window.toastr.error; //warning
            toastr('', 'Already in compare list', {
              positionClass: "toast-bottom-center",
              containerId: "toast-bottom-center"
            });
          } else {

            preschool_compare.push({
              id: id,
              type: type
            });

            localStorage.setItem('school_compare', JSON.stringify(preschool_compare));

            myDomEl.html(preschool_com_len);

            toastr = window.toastr.success;
            toastr('', 'Added To compare list', {
              positionClass: "toast-bottom-center",
              containerId: "toast-bottom-center"
            });

            $(".schootocompare").show();

          }
        } else {
          toastr = window.toastr.error; //warning
          toastr('', 'Only allow 3 Schools to compare', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
        }
      } else {
        console.log('else')
        let preschool_arr = [];
        preschool_arr.push({
          id: id,
          type: type
        });

        localStorage.setItem('school_compare', JSON.stringify(preschool_arr));

        $(".schootocompare").show();

        toastr = window.toastr.success;
        toastr('', 'Added To compare list', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });

      }

    } else {

      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('Please Login your account', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });

    }

  }

  subLinks = () => {
    localStorage.setItem('school_sublink', this.state.breadcrums)
    localStorage.setItem('school_sublink_id', this.props.match.params.category_id)
    window.location.replace('/schoollinks');
  }
  adlink(type, link) {
    let req = JSON.stringify({
      category_id: 1,
      page_id: this.props.match.params.id,
      customer_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      is_admission: type == 1 && true,
      is_website: type == 2 && true,
      url: 'clickcount'
    });
    commonAPI(req).then(res => {
      console.log('res', res);
    });
    window.open(
      link,
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  triggerReview = () => {
    document.getElementById("review-btn").click();
  }

  hideComponent_old(name) {
    //console.log(name);  

    const section = document.querySelector('#main_detail_header');
    section.scrollIntoView({ top: 0, behavior: 'smooth', block: 'start' });
    switch (name) {
      case "showHideComp1":
        this.setState({ showHideComp1: !this.state.showHideComp1, showHideComp2: false, showHideComp3: false, showHideComp4: false, showHideComp5: false, showHideComp6: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#aboutlink").addClass('active');
        break;
      case "showHideComp2":
        this.setState({ showHideComp2: !this.state.showHideComp2, showHideComp1: false, showHideComp3: false, showHideComp4: false, showHideComp5: false, showHideComp6: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#keyinfolink").addClass('active');
        break;
      case "showHideComp3":
        this.setState({ showHideComp3: !this.state.showHideComp3, showHideComp2: false, showHideComp1: false, showHideComp4: false, showHideComp5: false, showHideComp6: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#ratingslink").addClass('active');
        break;
      case "showHideComp4":
        this.setState({ showHideComp4: !this.state.showHideComp4, showHideComp5: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideComp6: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#reviewlink").addClass('active');
        break;
      case "showHideComp5":
        this.setState({ showHideComp5: !this.state.showHideComp5, showHideComp4: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideComp6: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#amentieslink").addClass('active');
        break;
      case "showHideComp6":
        this.setState({ showHideComp6: !this.state.showHideComp6, showHideComp5: false, showHideComp4: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideComp7: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#feeslink").addClass('active');
        break;
      case "showHideComp7":
        this.setState({ showHideComp7: !this.state.showHideComp7, showHideComp6: false, showHideComp5: false, showHideComp4: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideComp8: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#gallerylink").addClass('active');
        break;
      case "showHideComp8":
        this.setState({ showHideComp8: !this.state.showHideComp8, showHideComp7: false, showHideComp6: false, showHideComp5: false, showHideComp4: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideAdmissionProcess: false, showVideos: false, showHideCompContact: false });
        $("#ourbrancheslink").addClass('active');
        break;
      case "showHideCompContact":
        this.setState({ showHideCompContact: !this.state.showHideCompContact, showHideComp8: false, showHideComp7: false, showHideComp6: false, showHideComp5: false, showHideComp4: false, showHideComp3: false, showHideComp2: false, showHideComp1: false, showHideAdmissionProcess: false, showVideos: false });
        $("#contactlink").addClass('active');
        break;

      case "showHideAdmissionProcess":
        this.setState({
          showHideAdmissionProcess: !this.state.showHideAdmissionProcess,
          showHideComp1: false,
          showHideComp2: false,
          showHideComp3: false,
          showHideComp4: false,
          showHideComp5: false,
          showHideComp6: false,
          showHideComp7: false,
          showHideComp8: false,
          showHideCompContact: false,
          showVideos: false
        });
        $("#adminssionprocess").addClass('active');
        break;
      case "showVideos":
        this.setState({
          showVideos: !this.state.showVideos,
          showHideComp1: false,
          showHideComp2: false,
          showHideComp3: false,
          showHideComp4: false,
          showHideComp5: false,
          showHideComp6: false,
          showHideComp7: false,
          showHideComp8: false,
          showHideAdmissionProcess: false
        });
        $("#videos").addClass('active');
        break;
      default:
        null;
    }
  }

  hideComponent(name){

    //console.log(name);  

    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    $(".btnblock").removeClass('active');

    
    var whataction = name;
    
    let DetailData = JSON.stringify({
        vertical_city: localStorage.getItem('current_location'),
        ip: this.state.ip,
        city: this.state.user_city,
        state: this.state.user_state,
        country: this.state.country_name,
        user_id:(this.state.user_id=='')? 0 : this.state.user_id,
        page:window.location.href,
        event:whataction,
        counting:1
    });

    saveOnclicks(DetailData);

    switch (name) {
      case "showAbout":
        const about_section = document.getElementById('about_section');
        about_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#aboutlink").addClass('active');
        break;
      case "showKeyInfo":
        const keyinfo_section = document.getElementById('keyinfo_section');
        keyinfo_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#keyinfolink").addClass('active');
        break;
      case "showRatings":
        const ratings_section = document.getElementById('ratings_section');
        ratings_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#ratingslink").addClass('active');
        break;
      case "showReview":
        const review_section = document.getElementById('review_section');
        review_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#reviewlink").addClass('active');
        break;
      case "showFees":
        const fees_section = document.getElementById('fees_section');
        fees_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#feeslink").addClass('active');
        break;
      case "showAmenities":
        const amenities_section = document.getElementById('amenities_section');
        amenities_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#amentieslink").addClass('active');
        break;

      case "showGallery":
        const gallery_section = document.getElementById('gallery_section');
        gallery_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#gallerylink").addClass('active');
        break;
      case "showOurBranch":
        const ourbranch_section = document.getElementById('ourbranch_section');
        ourbranch_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#ourbrancheslink").addClass('active');
        break;
      case "showContact":
        const contactinfo_section = document.getElementById('contactinfo_section');
        contactinfo_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#contactlink").addClass('active');
        break;
      case "showAdmissionProcess":
        const admission_section = document.getElementById('admission_section');
        admission_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#adminssionprocess").addClass('active');
        break;
      case "showVideos":
        const video_section = document.getElementById('video_section');
        video_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#videos").addClass('active');
        break;
      default:
        null;
    }
  }


  render() {

    let topTrendingforArticles = {
      category_id: this.props.match.params.category_id,
      sub_category: 0
    }

   

    const settings_of_similar = {
      dots: false,
      infinite: false,
      speed: 500,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    const { showing, showcp, shownotecp } = this.state;
    const { school, error } = this.state;

    const { showHideComp1,
      showHideComp2,
      showHideComp3,
      showHideComp4,
      showHideComp5,
      showHideComp6,
      showHideComp7,
      showHideComp8,
      showHideAdmissionProcess,
      showVideos,
      showHideCompContact } = this.state;



    if (school === null) {
      return (
        <React.Fragment>
          <div class="overlay-custom"></div>
          <Header />
          <div class='spinner' role='status'>
            <span class='sr-only'>Loading...</span>
          </div>
          <div className='preloadDiv'></div>
          <Footer />
        </React.Fragment>
      );
    }

    const {
      schoolName,
      category_name,
      address,
      location,
      teacher_student_ratio,
      admission_process,
      website,
      phone_number,
      email_id,
      other_fee,
      addmission_fee,
      is_refundable,
      establishment_Year,
      instruction_lang,
      about_school,
      google_location,
      photos,
      images,
      avg_anual_fee,
      grade,
      grade_to,
      grades,
      min_age,
      classification,
      school_timimg,
      required_document,
      fax_number,
      board_of_education,
      landline_number,
      latitude,
      longitude,
      from_time,
      to_time,
      school_type,
      doc_arr,
      admission_link,
      pincode,
      other_rating,
      has_scholarship,
      scholarship_desc,
      video_path,
      facilites,
      admission_open,
      admission_closed,
      current_vacancies,
      seats_in,
      vendor_id,
      url,
      subcategoryname, social_link_data
    } = school;

    const {authe} = this.state;
    
    let review = {
      review_id: this.state.school.page_id,
      user_id: this.state.user_id,
      keyword: 1,
      last_review_date: this.state.last_review_date,
      vendor_id: this.state.school.vendor_id
    }


    let videoParm = {
      is_like: 0,
      type: 3,
      user_id: this.state.user_id,
      ref_id: this.state.school.page_id,
      vendor_id: this.state.school.vendor_id,
      main_category: 1,
      category: this.props.match.params.subcategory,
    }

    let phone_number_info = {
      email_id: email_id,
      phone_number_info: this.state.phone_number_info,
      category_id: 1,
      category: this.props.match.params.category_id,
      id: this.props.match.params.id,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
    }

    let commentParm = {
      category_id: 1,
      category: this.props.match.params.category_id,
      id: this.props.match.params.id,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
    }

    let newcommentsParm = {
      category_id: 1,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.schooname,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      whichtable: 'schools'
    }
    let retailData = {
      category_id: 1,
      subcategory_name: this.props.match.params.subcategory,
      location: this.props.match.params.city,
    }


    let likefollowParm = {
      category_id: 1,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.schooname,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      whichtable: 'schools'
    }


    let likeParm = {
      category_id: 1,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.schooname,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      whichtable: 'schools',
      scope: 'like'
    }


    let followParm = {
      category_id: 1,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.schooname,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      whichtable: 'schools',
      scope: 'follow'
    }


    let wishlistParm = {
      category_id: 1,
      category: this.props.match.params.subcategory,
      id: this.state.school.id,
      user_id: this.state.user_id,
      vendor_id: this.state.school.vendor_id,
      full_url: window.location.href
    }

    let similar = {
      module: 1,
      ref_name: this.props.match.params.schooname,
      category_name: this.props.match.params.subcategory,
      route: this.props.match.params.city + "/schools/" + this.props.match.params.subcategory,
      whichtable: 'schools'
    }
    let invitedata = {
      url: window.location.href,
      share_name: schoolName,
      vendor_id: this.state.school.vendor_id,
      module: 1,
      category: this.props.match.params.category_id,
      category_name: 'School'
    }

    let reviewinfo = newcommentsParm;
    let aboutinfo = about_school;

    let annualfees = avg_anual_fee;
    let recurringfees = addmission_fee;

    let galleryinfo = this.state.photo_path;

    let ratinginfo = this.state.rating;

    let ourbranchesinfo = '';

    let amenities = facilites;

    const keyinfosettings = {
      dots: true,
      infinite: false,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    let keyinfo = <div className='keyinfosec'>
      <div class="desktoponly">
        <div className='row'>
          <div className='col-4'>
            <div className='ki_title'>School Type </div>
            <div className='ki_ans'>{subcategoryname}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Board Of Education </div>
            <div className='ki_ans'>{board_of_education}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Classes </div>
            <div className='ki_ans'>{grades}</div>
          </div>
        </div>
        <div className='row n8frx'>
          <div className='col-4'>
            <div className='ki_title'>Min Age of Admission </div>
            <div className='ki_ans'>{min_age}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Instruction Language </div>
            <div className='ki_ans'>{instruction_lang}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Establishment Year </div>
            <div className='ki_ans'>{establishment_Year}</div>
          </div>
        </div>
        <div className='row n8frx'>
          <div className='col-4'>
            <div className='ki_title'>Landline Number</div>
            <div className='ki_ans'>
              {(this.state.authe === false) ?
                <div onClick={this.toggleModalopen}>
                  <span > Click to View/Call</span>
                </div>
                :

                <span onClick={() => this.changelandline_noState(landline_number)}>
                  {this.state.landline_number}
                </span>
              }

            </div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>School Timing</div>
            <div className='ki_ans'>
              {(from_time == 'NA' || to_time == 'NA') ? 'NA' : from_time + ' To ' + to_time}
            </div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Location </div>
            <div className='ki_ans'>{location}</div>
          </div>

        </div>
        <div className='row n8frx'>

          <div className='col-4'>
            <div className='ki_title'>Teacher:Student Ratio </div>
            <div className='ki_ans'>{teacher_student_ratio}</div>
          </div>
          {/* <div className='col-md-4'>
                            <div className='type-n7ngd'>Classification</div>
                            <div className='key-po'>{classification}</div>
                          </div> */}
          <div className='col-4'>
            <div className='ki_title'>Is Refundable (Admission Fees)</div>
            <div className='ki_ans'>{(is_refundable == 1) ? 'Yes' : 'No'}</div>
          </div>
        </div>
        <div className='row n8frx'>

          <div className='col-4'>
            <div className='ki_title'>Scholarship Facility </div>
            <div className='ki_ans'>
              {(has_scholarship == undefined || has_scholarship == '0') &&
                ('NA')
              }
              {(has_scholarship == '2') &&
                ('No')
              }
              {(has_scholarship == '1') &&
                (`Yes, ${scholarship_desc}`)
              }
            </div>
          </div>
        </div>
      </div>
      <div class="mobileonly">
        <Slider ref={c => (this.slider = c)} {...keyinfosettings} >

          <div className='cardblock'>
            <div class="stacklist">
              <div className='ki_title'>School Type </div>
              <div className='ki_ans'>{subcategoryname}</div>
            </div>
            <div class="stacklist">
              <div className='ki_title'>Board Of Education </div>
              <div className='ki_ans'>{board_of_education}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Grades </div>
              <div className='ki_ans'>{grades}</div>
            </div>
          </div>

          <div className='cardblock'>
            <div class="stacklist">
              <div className='ki_title'>Min Age of Admission </div>
              <div className='ki_ans'>{min_age}</div>
            </div>
            <div class="stacklist">
              <div className='ki_title'>Instruction Language </div>
              <div className='ki_ans'>{instruction_lang}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Establishment Year </div>
              <div className='ki_ans'>{establishment_Year}</div>
            </div>

          </div>


          <div className='cardblock'>

            <div class="stacklist">
              <div className='ki_title'>Instruction Language </div>
              <div className='ki_ans'>{instruction_lang}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Establishment Year </div>
              <div className='ki_ans'>{establishment_Year}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Landline Number</div>
              <div className='ki_ans'>
                {(this.state.authe === false) ?
                  <div onClick={this.toggleModalopen}>
                    <span > Click to View/Call</span>
                  </div>
                  :

                  <span onClick={() => this.changelandline_noState(landline_number)}>
                    {this.state.landline_number}
                  </span>
                }

              </div>
            </div>

          </div>


          <div className='cardblock'>

            <div class="stacklist">
              <div className='ki_title'>Landline Number</div>
              <div className='ki_ans'>
                {(this.state.authe === false) ?
                  <div onClick={this.toggleModalopen}>
                    <span > Click to View/Call</span>
                  </div>
                  :

                  <span onClick={() => this.changelandline_noState(landline_number)}>
                    {this.state.landline_number}
                  </span>
                }

              </div>

            </div>
            <div class="stacklist">

              <div className='ki_title'>School Timing</div>
              <div className='ki_ans'>
                {(from_time == 'NA' || to_time == 'NA') ? 'NA' : from_time + ' To ' + to_time}
              </div>

            </div>
            <div class="stacklist">
              <div className='ki_title'>Location </div>
              <div className='ki_ans'>{location}</div>
            </div>
          </div>

          <div className='cardblock'>

            <div class="stacklist">
              <div className='ki_title'>Teacher:Student Ratio </div>
              <div className='ki_ans'>{teacher_student_ratio}</div>
            </div>
            <div class="stacklist">
              <div className='ki_title'>Is Refundable (Admission Fees)</div>
              <div className='ki_ans'>{(is_refundable == 1) ? 'Yes' : 'No'}</div>
            </div>
            <div class="stacklist">

              <div className='ki_title'>Scholarship Facility </div>
              <div className='ki_ans'>
                {(has_scholarship == undefined || has_scholarship == '0') &&
                  ('NA')
                }
                {(has_scholarship == '2') &&
                  ('No')
                }
                {(has_scholarship == '1') &&
                  (`Yes, ${scholarship_desc}`)
                }
              </div>

            </div>
          </div>
        </Slider>
         
      </div>
    </div>;


    const similarsettings = {
      dots: false,
      infinite: false,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: 'summercamps',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    const gallerysettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    const orgphoto = (school.images!='')? AZ_ASSET_PATH+school.images:placeholderimage;
    var buildingphotos = (school.photos!='') ? school.photos.split(",") :[];
    const propertyimageasBg = (school.photos!='')? AZ_ASSET_PATH+buildingphotos[0]:placeholderbgimage;

    return (
      <React.Fragment>

        
        <div className="body-custom-class">
          <Header login={this.state.openModalLogin} />

          <div className='container'>
            <div className='row display-flex-center main_detail_header' id="main_detail_header">
              <div className='col-lg-12 col-md-12 col-xs-12 nopadleft nopadright'>
                <div className='detailBanner' style={{backgroundImage:`linear-gradient(45deg, rgb(71 66 245 / 91%), rgb(186 195 203 / 75%)), url(`+propertyimageasBg+`)`}}>
                  <div className="row display-flex-center">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                      <div class="breadcrumbsv2 new-breadcrumbs-v2">
                        <div class="bcitem"><span>Home</span></div>
                        <div class="bcitem_div"></div>
                        <div class="bcitem"><span>Schools</span></div>
                        <div class="bcitem_div"></div>
                        <div class="bcitem"><a href={this.state.secondbrdcrm}>{this.state.breadcrums}</a></div>
                      </div>
                    </div>

                    <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                      <div className="ver_detail_block desktoponly">
                        <div className="row">
                          <div className="displayflex">
                            <div class="per40image">
                              <img src={orgphoto} className="img-fluid" />
                            </div>
                            <div class="per50">

                            <div class="displayflex"> 
                                <div class="orginfo">
                                    <div className="org_name">{schoolName} &nbsp; {school.stamp_img && <img className='stamp-view' src={school.url + school.stamp_img} />}</div>
                                    <div className="org_address">{address}</div>
                                </div>
                                <div class="orgfollows">
                                {(this.state.authe === false) ?
                                    <div class="likes" onClick={this.toggleModalopen}>
                                    <LikeOnlyV2 paramId={likeParm} />
                                    </div>
                                    : 
                                    <div class="likes">
                                    <LikeOnlyV2 paramId={likeParm} />
                                    </div>
                                }

                                    {(this.state.authe === false) ?
                                    <div class="follows" onClick={this.toggleModalopen}>
                                        
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div> :
                                     <div class="follows">
                                         
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div>
                                    }
                                </div>
                              </div>  
                              <div class="row paddingleft20">

                                <div class="col-12">
                                    <div className="bewiseratingsv1">
                                        <div>Bewise Ratings: </div>
                                        <div>
                                        <Rating className="col-5 col-md-4 col-5 col-md-4"
                                                               name={"bewiserating"}
                                                               editing={false}
                                                               value={ratinginfo.totalReview}
                                        />
                                </div></div></div>

                                <div class="col-12">
                                    <div className="googleratingsv1">
                                        <div>Google Ratings:</div>
                                        <div>
                                        <Rating className="col-5 col-md-4 col-5 col-md-4"
                                                               name={"googlerating"}
                                                               editing={false}
                                                                
                                                               value={other_rating}                                                                 
                                                                
                                        />
                                        </div></div></div>

                              </div>

                              <div class="row">
                              <div class="actionicons pull-right">
                              <div class="alignicons">
                                <div class="actionbutv2" onClick={this.addtocompare} title="Compare">
                                  Compare
                                </div>
                              </div>

                              {(this.state.authe === false) ? (

                                <div class="alignicons">
                                  <div id='review-btn' class="actionbutv2" onClick={this.toggleModalopen} title="Write Review">
                                      Write Review
                                  </div>
                                  
                                </div>
                              )
                                :

                                <ReviewSchools data={review} />
                              }
                              <div class="alignicons">
                                  <div className="actionbutv2" title="Share" id="socialShareIconsNew">
                                    Share
                                  </div>
                                   
                              </div>
                              <div className="main-social-icons">
                                <UncontrolledPopover trigger="legacy" placement="bottom" target="socialShareIconsNew">
                                  <PopoverBody>
                                    <div className="share-icon-social">
                                      <SocialMediaButtons url={this.state.shareurl} text={schoolName} />
                                    </div>
                                  </PopoverBody>
                                </UncontrolledPopover>
                              </div>
                              <AddWishlistNewV1 paramId={wishlistParm} />
                              <div class="alignicons">

                                {vendor_id<=1 &&
                                <div className="actionbutv2" onClick={() => this.setState({ shownotecp: true })} title="Contact the Center">
                                Enquire Now
                                </div>
                                }

                                {vendor_id>1 && 
                                  <div className="actionbutv2" onClick={() => this.setState({ showcp: true })} title="Contact the Center">
                                  Enquire Now
                                  </div>
                                }
 
                                 
                              </div>
                            </div>
                              </div>

                            </div>
                          </div>
                        </div>

                         

                  <div class="row justify-content-end hidden">
                      <div class="col-md-2">
                      <div class="newactbtn">
                        <button type="button" class="btn mb-2 mb-md-0 btn-primary btn-block btn-pink-round"><span>Compare</span>
                        <div class="icon icon-round d-flex align-items-center justify-content-center">
                          <ion-icon name="git-compare-outline"></ion-icon>
                        </div>
                        </button>
                      </div>
                      </div>
                      <div class="col-md-2">
                        <div class="newactbtn">
                          <button type="button" class="btn mb-2 mb-md-0 btn-primary btn-block btn-pink-round"><span>Write Review</span>
                          <div class="icon icon-round d-flex align-items-center justify-content-center">
                            <ion-icon name="clipboard-outline"></ion-icon>
                          </div>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="newactbtn">
                          <button type="button" class="btn mb-2 mb-md-0 btn-primary btn-block btn-pink-round"><span>Share</span>
                          <div class="icon icon-round d-flex align-items-center justify-content-center">
                            <ion-icon name="share-social-outline"></ion-icon>
                          </div>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="newactbtn">
                          <button type="button" class="btn mb-2 mb-md-0 btn-primary btn-block btn-pink-round"><span>Wishlist</span>
                          <div class="icon icon-round d-flex align-items-center justify-content-center">
                            <ion-icon name="heart-outline"></ion-icon>
                          </div>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="newactbtn">
                          <button type="button" class="btn mb-2 mb-md-0 btn-primary btn-block btn-pink-round"><span>Service Provider</span>
                          <div class="icon icon-round d-flex align-items-center justify-content-center">
                            <ion-icon name="call-outline"></ion-icon>
                          </div>
                          </button>
                        </div>
                      </div>
                  </div>

                      </div>

                      <div className="ver_detail_block mobileonly">

                        <div className="row">
                          <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center no-padding">

                            <div class="per100">
                              <div className="org_name">{schoolName}</div>
                            </div>
                            <div class="per100">
                               
                                <div class="orginfo">
                                   <img src={orgphoto} className="orgphoto" />
                                </div>
                                
                               
                            </div> 
                            <div class="per100">
                              <div className="org_address">{address}</div>
                            </div>  
                            <div class="per100">
                            <div class="orgfollows">

                                    {(this.state.authe === false) ?
                                        <div class="likes" onClick={this.toggleModalopen}>
                                        <LikeOnlyV2 paramId={likeParm} />
                                        </div>
                                        : 
                                        <div class="likes">
                                        <LikeOnlyV2 paramId={likeParm} />
                                        </div>
                                    }

                                    {(this.state.authe === false) ?
                                    <div class="follows" onClick={this.toggleModalopen}>
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div> :
                                     <div class="follows">
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div>
                                    }

                            </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                            <div class="bewiseratings_section">
                                  <div className="bewiseratingsv1">Bewise Ratings: <Rating 
                                                              name="facilities"
                                                              starCount={5}
                                                              value={this.state.totalReview}/>
                                  </div>
                                  <div className="bewiseratingsv1">Google Ratings:  <Rating 
                                                              name="facilities"
                                                              starCount={5}
                                                              value={other_rating}/>
                                  </div>
                              </div>
                            </div>
                        
                          <div>
                      <div className="ver_action_block mobile">
                          
                          <div class="flexiblecolumn text-center">

                              <div class="colmn">
                                
                                <div class="alignicons">
                                <div class="actionbutv2" onClick={this.addtocompare} title="Compare">
                                    Compare
                                </div>
                                
                                </div>

                              </div>

                              <div class="colmn">
                                {(this.state.authe === false) ? (

                                <div class="alignicons">
                                  <div id='review-btn' class="actionbutv2" onClick={this.toggleModalopen} title="Write Review">
                                    Review
                                  </div>
                                  
                                </div>
                              )
                                :

                                <ReviewSchools data={review} />
                              }
                              </div>

                              <div class="colmn">
                              <div class="alignicons">
                                  <div className="actionbutv2" title="Share" id="socialShareIconsNew">
                                      Share
                                  </div>
                                  
                              </div>
                              <div className="main-social-icons">
                                <UncontrolledPopover trigger="legacy" placement="bottom" target="socialShareIconsNew">
                                  <PopoverBody>
                                    <div className="share-icon-social">
                                      <SocialMediaButtons url={this.state.shareurl} text={schoolName} />
                                    </div>
                                  </PopoverBody>
                                </UncontrolledPopover>
                              </div>
                              </div>

                              <div class="colmn">
                                <AddWishlistNewV1 paramId={wishlistParm} />
                              </div>

                              <div class="colmn">
                                <div class="alignicons">

                                   {vendor_id<=1 &&
                                    <div className="actionbutv2" onClick={() => this.setState({ shownotecp: true })} title="Contact the Center">
                                    Enquire Now
                                    </div>
                                    }
    
                                    {vendor_id>1 && 
                                      <div className="actionbutv2" onClick={() => this.setState({ showcp: true })} title="Contact the Center">
                                      Enquire Now
                                      </div>
                                    }

                               
                                
                              </div>
                              </div>

                          </div>
                           

                      </div>

                    </div>

                        </div>

                      </div>
                    </div>
                    <div className="col-lg-1 col-sm-12 col-md-12 col-xs-12 desktoponly">&nbsp;
                    </div>
                    
                  </div>

                </div>
              </div>
            </div>

            <div className="row desktoponly" id="floatinmid">

              <div className="col-lg-6 col-sm-12 col-md-6 col-xs-6 text-center">

                <div class="breadcrumbsv3">
                  <div class="bcitem"><a href={'/'}>Home</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem"><a href={this.state.firstbrdcrm}>Schools</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem"><a href={this.state.secondbrdcrm}>{this.state.breadcrums}</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem itemhighlighted">{schoolName}</div>
                </div>

              </div>
              <div className="col-lg-6 col-sm-12 col-md-6 col-xs-6 text-center">

                <div className="ver_action_block_in_bar desktoponly">
                  <div class="row display-flex-center">
                    <div class="col-2 text-center actionbtn" title="Compare" onClick={this.addtocompare} onclick="ga(‘send’, ‘event’, 'schools', Get Direction, ‘label’, value, {‘NonInteraction’: 1});">
                      <div className="icondiv"><img src={actionicon1} /></div>

                    </div>


                    <div class="col-2 text-center actionbtn" title="Write Review" onClick={() => this.writereview()}>
                      <div className="icondiv"><img src={actionicon2} /></div>

                    </div>

                    <div class="col-2 text-center actionbtn" title="Share">
                      <div className="icondiv"><img src={actionicon4} id="socialShareIconsMob" /></div>
                      <div className="main-social-icons">
                        <UncontrolledPopover trigger="legacy" placement="bottom" target="socialShareIconsMob">
                          <PopoverBody>
                            <div className="share-icon-social">
                              <SocialMediaButtons url={this.state.shareurl} />
                            </div>
                          </PopoverBody>
                        </UncontrolledPopover>
                      </div>
                    </div>

                    <AddWishlistNewV1inBar paramId={wishlistParm} />

                     
                                {vendor_id<=1 &&
                                <div className="actionbutv2" onClick={() => this.setState({ shownotecp: true })} title="Contact the Center">
                                Enquire Now
                                </div>
                                }

                                {vendor_id>1 && 
                                  <div className="actionbutv2" onClick={() => this.setState({ showcp: true })} title="Contact the Center">
                                  Enquire Now
                                  </div>
                                }

                  </div>

                </div>

              </div>

            </div>

            <div className="row">

              <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center">
                <div class="oneAd"><AdHorizontal /></div>
              </div>

            </div>

            <div className="row main_info">

              <div className="col-lg-2 col-sm-12 col-md-12 col-xs-12 text-center nopadleftright infoBlock">

               { /*
                <div class="onDemandInfoLinks">
                  <div className="btnblock active" id="aboutlink">
                    <div className="normallinkbtn">
                      <a href="#about_section">About</a></div>
                  </div>
                  <div className="btnblock" id="keyinfolink">
                    <div className="normallinkbtn" >
                      <a href="#keyinfo_section">Key Information</a> </div>
                  </div>

                  <div className="btnblock" id="ratingslink">
                    <div className="normallinkbtn">
                      <a href="#ratings_section">Ratings </a></div>
                  </div>


                  <div className="btnblock" id="reviewlink">
                    <div className="normallinkbtn" >
                      <a href="#review_section">Reviews/ Comments</a> </div>
                  </div>

                  <div className="btnblock" id="amenitieslink">
                    <div className="normallinkbtn" >
                      <a href="#amenities_section">Amenities/ Facilities</a> </div>
                  </div>

                  <div className="btnblock" id="feeslink">
                    <div className="normallinkbtn" >
                      <a href="#fees_section">Fees & Structure </a></div>
                  </div>

                  <div className="btnblock" id="adminssionprocess">
                    <div className="normallinkbtn" >
                      Admission Process </div>
                  </div>

                  <div className="btnblock" id="gallerylink">
                    <div className="normallinkbtn" >
                      Gallery </div>
                  </div>

                  <div className="btnblock" id="videos">
                    <div className="normallinkbtn" >
                      Videos </div>
                  </div>

                  <div className="btnblock" id="ourbrancheslink">
                    <div className="normallinkbtn" >
                      Our Branches </div>
                  </div>


                  <div className="btnblock" id="contactlink">
                    <div className="normallinkbtn" >
                      Contact Info </div>
                  </div>

                </div> */ }

                 <div class="onDemandInfoLinks">

                  <div className="btnblock active" id="aboutlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showAbout")}>
                      About </div>
                  </div>

                  <div className="btnblock" id="keyinfolink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showKeyInfo")}>
                      Key Information </div>
                  </div>

                  <div className="btnblock" id="ratingslink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showRatings")}>
                      Ratings </div>
                  </div>


                  <div className="btnblock" id="reviewlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showReview")}>
                      Reviews/ Comments </div>
                  </div>

                  <div className="btnblock" id="amenitieslink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showAmenities")}>
                      Amenities/ Facilities </div>
                  </div>

                  <div className="btnblock" id="feeslink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showFees")}>
                      Fees & Structure </div>
                  </div>

                  <div className="btnblock" id="adminssionprocess">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showAdmissionProcess")}>
                      Admission Process </div>
                  </div>

                  <div className="btnblock" id="gallerylink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showGallery")}>
                      Gallery </div>
                  </div>

                  <div className="btnblock" id="videos">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showVideos")}>
                      Videos </div>
                  </div>

                  <div className="btnblock" id="ourbrancheslink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showOurBranch")}>
                      Our Branches </div>
                  </div>


                  <div className="btnblock" id="contactlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showContact")}>
                      Contact Info </div>
                  </div>

                  <AdVerticalLeft />

                </div> 

                

              </div>

              <div className="col-lg-8 col-sm-12 col-md-12 col-xs-12 text-center">

                <div class="onDemandInfo" id="onDemandInfo">
                  <div class="section_to_scroll">
                  <Suspense fallback={<Loading />}>
                  <Comp1 paraminfo={aboutinfo} />
                  </Suspense>
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <Comp2 paraminfo={keyinfo} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <Comp3 paraminfo={ratinginfo} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <div id="review_section">
                    <h3 className="review_head" onClick={this.triggerReview}>Review
                      {this.state.authe && this.state.noofreview > 0 && (` (${this.state.noofreview})`)}
                      <div style={{ float: 'right' }}>
                        <small className='pointer'>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </small>
                      </div>
                    </h3>
                    <div class="reviewinfo">
                      {(this.state.authe === false) ?
                        <div className="col-md-12" onClick={this.toggleModalopen}>
                          <div class="detailBox">
                            <div className="form-comments">
                              <p>Click here to view Comments!...</p>
                            </div>
                          </div>
                        </div>
                        :
                        <div className="col-md-12">
                          <CommentsNew paramId={newcommentsParm} />
                        </div>
                      }
                    </div>
                  </div>
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <Comp5 paraminfo={amenities} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <div id="admission_section"><h3>Admission Process</h3>
                    <div className='row n6vgl'>
                      <div className='col-md-12'>
                        {(admission_open!=null && admission_open!='') && 
                        <p className="mb-0">
                          <span className='n7vd6h'>Admission Open in: </span>
                          <span className='ad-link'>
                              {admission_open}
                          </span>
                        </p>
                        }

                        {(admission_closed!=null && admission_closed!='') && 
                        <p className="mb-0">
                          <span className='n7vd6h'>Admission Closing in: </span>
                          <span className='ad-link'>
                              {admission_closed}
                          </span>
                        </p>
                        }

                        <p className="mb-0">
                          <span className='n7vd6h'>Admission Link : </span>
                          <span className='ad-link'>
                            {admission_link && <span onClick={() => this.adlink(1, admission_link)} style={{ wordBreak: "break-all", cursor: 'pointer' }}>{admission_link}</span>}
                            {/* <a href={admission_link} target='_blank'><span style={{ wordBreak: "break-all" }}>{admission_link}{' '}</span></a> */}
                          </span>
                        </p>
                        <p>
                          <span className='n7vd6h'>Admission Process :</span>{' '}
                          <span className='m8bx4bg'>{admission_process}</span>
                        </p>

                        <p>
                          <span className='n7vd6h'>Current Vacancies :</span>{' '}
                          <span className='m8bx4bg'>{current_vacancies}</span>
                        </p>
                        {current_vacancies=='Available' &&
                        <p>
                          <span className='n7vd6h'>Seats In :</span>{' '}
                          <span className='m8bx4bg'>{Seats}</span>
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <Comp6 toggleModalopen={this.toggleModalopen} annualfee={annualfees} recurringfee={recurringfees} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <div id="gallery_section"><h3>Gallery</h3>
                    {galleryinfo.length == 0 &&
                      <div>No Gallery</div>
                    }
                    {galleryinfo.length > 0 &&
                      <Slider {...gallerysettings}>
                        {
                          galleryinfo && galleryinfo.map((d) => {
                            return (

                              <div className="text-center"><img src={d.src} width="200px" /></div>
                            )

                          })
                        }
                      </Slider>
                    }
                  </div>
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <CompVideos toggleModalopen={this.toggleModalopen} url={url} video_path={video_path} videoParm={videoParm} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <Comp8 paraminfo={ourbranchesinfo} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <CompContact phone={phone_number} email={email_id} />
                  </div>
                  <br />
                  <div class="section_to_scroll">
                  <RetailList retail={retailData} />
                  </div>
                </div>

              </div>

              <div className="col-lg-2 col-sm-12 col-md-12 col-xs-12 text-center nopadleftright">

                <div class="rightSideBar">

                  <div className="right-side-box listingad">
                            
                                <a href={leadlink}><img src={leadad} /></a>
                  </div>

                  <div class="rsb latestarticles">

                    <h3>Articles</h3>
                    <div class="artcileslist desktoponly">

                      <ul className='related-topics'>
                        {this.state.contentList.map((content, i) => {
                          let THIS = this;
                          let cont = (content.title.length > 40) ? content.title.substring(0, 40) + '... ' : content.title;
                          let bannerimg = (content.banner_image) ? content.banner_image : 'https://api.bewise.in/uploads/insights/insight_bannerbraznx.png';
                                  
                          return (
                            <React.Fragment>
                              <div className='row insight-list-page bloglistSp'>
                                <div className='col-md-3'>
                                   
                                    <img src={bannerimg} className="insight-home-custome-img" alt='Banner Image' />
                                   
                                </div>
                                <div className='col-md-9 blogSp relatedLi'>
                                  <p className=''>{cont}</p>
                                  <small> <a href={BASE_URL + 'articles-blogs/' + content.slug_term} target='_blank' className="" >Read More</a></small>
                                </div>
                              </div>
                            </React.Fragment>
                            // <li className="relatedLi">
                            //     <span className=''>{cont}</span>
                            //     <small> <a href={'insight-details/' + content.insight_id} target='_blank' className="" >Read More</a></small>
                            // </li>

                          )
                        })}

                      </ul>

                    </div>
                    <div class="artcileslist mobileonly">
                      <InnerArticles />
                    </div>

                  </div>

                  <AdVertical />

                </div>

              </div>

            </div>

            <div className="row">

              <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 mobileview">

                <div class="similaritems">
                  <h5>Similar {this.state.category_name}</h5>
                  <div class="similarslist">
                    {this.state.similarList.length > 0 &&

                      <Slider {...similarsettings} >

                        {this.state.similarList.map((item, index) => {
                          return (
                            <div class="hover1" style={{ 'padding': '10px' }}>
                              <div class="img-school s6g6bd" style={{ backgroundImage: `url('${item.images}')` }} ><div class="conntent-bottom">
                                <div class="r5b99d">
                                  <a href={item.link}>
                                    <span class="g4yb">{item.name}</span></a>
                                </div>
                              </div>
                              </div>
                            </div>
                          );
                        })
                        }
                      </Slider>

                    }
                    {this.state.similarList.length == 0 &&
                      <div>No Similar Items Found</div>
                    }
                  </div>
                </div>
              </div>

            </div>


          </div>


          <Footer />

                
                <Modal isOpen={shownotecp} centered size='lg'>

                <ModalBody>
                  <h4 class='csph4'>Contact {schoolName}</h4>
                
                  <button
                                className='close-btn'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={this.handleCloseNoteCp}
                              >
                                <img src={closebtn} alt='close' />
                              </button>
                
                  <div>This institution has not yet collaborated with us.  Kindly call / write to them directly with contact information provided below </div>
                  </ModalBody>
                  </Modal>

          <Modal isOpen={showcp} centered size='lg'>

            <ModalBody>
            {(authe) &&
              <h4 class='csph4'>Contact {schoolName}</h4>
            }
              <button
                className='close-btn'
                data-dismiss='modal'
                aria-label='Close'
                onClick={this.handleCloseCp}
              >
                <img src={closebtn} alt='close' />
              </button>
              {(authe) &&
              <div class="formbox csp">
                <form
                  method='post'
                  onSubmit={this.handleSubmit}
                  autoComplete='off'
                  id='loginForm'
                >
                  <div
                    className='form-group has-feedback'
                    style={{ width: '55%', float: 'left' }}
                  >
                    <label className='n7tr' >
                      First Name
                    </label>
                    <input
                      type='text'
                      name='first_name' onChange={this.handleChange}
                      className='form-control' value={this.state.first_name} required
                    />

                  </div>
                  <div
                    className='form-group has-feedback'
                    style={{ width: '40%', float: 'right' }}
                  >
                    <label className='n7tr' >
                      Last Name
                    </label>
                    <input
                      type='text'
                      name='last_name' onChange={this.handleChange}
                      className='form-control' value={this.state.last_name} required
                    />

                  </div>
                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Mobile Number
                    </label>
                    <input
                      type='text'
                      name='reg_mobile' onChange={this.handleChange}
                      className='form-control' required
                    />

                  </div>
                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Email ID
                    </label>
                    <input
                      type='text'
                      name='reg_email' onChange={this.handleChange}
                      className='form-control' value={this.state.email_id}  required
                    />

                  </div>

                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Any Message
                    </label>
                    <textarea

                      name='any_message' onChange={this.handleChange}
                      value={this.state.any_message}

                      className='form-control' required
                    />
                  </div>

                  <div className='form-group has-feedback'>
                    <input
                      type='submit'
                      name='submit'
                      value='Submit'
                      className='submit btn btn-primary btn-block btn-css'
                    />
                  </div>
                </form>
              </div>
              }
              {(!authe) &&
                 <div>Sign up with us to enable this feature</div>
              }
            </ModalBody>

          </Modal>

          <nav class="floating-menu hidden" id="sideMenuContainer">

            <a href="#about_section" id="about" class="menuitem" onClick={() => this.handleclickhide('about')}>About</a>
            <a href="#keyinfo_section" id="key" class="menuitem" onClick={() => this.handleclickhide('key')}>Key Information</a>

            <a href="#ratings_section" id="ratings" class="menuitem" onClick={() => this.handleclickhide('ratings')}>Ratings</a>
            <a href="#review_section" id="reviews" class="menuitem" onClick={() => this.handleclickhide('reviews')}>Reviews/ Comments</a>
            <a href="#amenities_section" id="amen" class="menuitem" onClick={() => this.handleclickhide('amen')}>Amenities/ Facilities</a>
            <a href="#fees_section" id="fees" onClick={() => this.handleclickhide('fees')}>Fees & Structure</a>
            <a href="#admission_section" id="admission" onClick={() => this.handleclickhide('admission')}>Admission Process</a>
            <a href="#gallery_section" id="gallery" onClick={() => this.handleclickhide('gallery')}>Gallery</a>
            <a href="#video_section" id="video" onClick={() => this.handleclickhide('video')}>Videos</a>
            <a href="#ourbranch_section" id="ourbranch" onClick={() => this.handleclickhide('ourbranch')}>Our Branches</a>
            <a href="#contactinfo_section" id="contactinfo" onClick={() => this.handleclickhide('contactinfo')}>Contact Info</a>
          </nav>

          <div className="floating-menu-btn" onClick={() => this.handleclick()}><i className="fa fa-bars" aria-hidden="true"></i></div>
          {/* <div className="floating-menu-close-btn hidden" onClick={() => this.handleclose()}>Close</div> */}
        </div>
      </React.Fragment >
    );
  }

}

export default SingleSchoolPageV3;
